/* # =================================================================
# Archiveに戻るボタン制御
# ================================================================= */
export default function goArchive() {
	const goArchiveElement = document.querySelector('#goArchive');
	const singleCardElement = document.querySelector('.single__card');
	const footerElement = document.querySelector('.footer');

	// エレメントが存在しない場合は早期に処理を終了
	if (!goArchiveElement || !singleCardElement || !footerElement) return;

	window.addEventListener('scroll', () => {
		const singleCardBottom = singleCardElement.getBoundingClientRect().bottom;
		const footerTop = footerElement.getBoundingClientRect().top + 100;

		if (singleCardBottom <= window.innerHeight && footerTop > window.innerHeight) {
			goArchiveElement.classList.add('show');
		} else {
			goArchiveElement.classList.remove('show');
		}
	});
}
